export default __webpack_public_path__ + "static/media/Treasurer.e7bb524a.jpg";